export default __webpack_public_path__ + "static/media/down.b6436bc9.svg";